const singularOrPlural = (count: number, unit: string) => {
  const countIsSingular = () => (unit.endsWith("s") ? unit.slice(0, -1) : unit);
  const countIsPlural = () => (!unit.endsWith("s") ? unit + "s" : unit);

  return count === 1 ? countIsSingular() : countIsPlural();
};

export default singularOrPlural;
